import { Block } from 'slate';
import BlockTypes from '../../../types/BlockTypes';
export default function allowDecoration(block) {
  return Block.isBlock(block) && !Block.isBlockList(block.nodes) && ![BlockTypes.CODE, BlockTypes.CODES].includes(block.type);
}